import React from 'react';
import PropTypes from 'prop-types';
import { HeaderImage, HeaderTypography } from './StyledComponents';
import { hasValue } from 'swipeclock-frontend';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

/**
 * React Component for White Label Logo
 * @param {Object} props - Component props
 * @param {Object} props.whiteLabelState - The white label state object containing logo and branding info
 * @param {string} props.whiteLabelState.urlLogo - URL of the logo image
 * @param {boolean} props.whiteLabelState.hasWhiteLabelClient - Whether white label client exists
 * @param {boolean} props.whiteLabelState.isEnclosedMode - Whether in enclosed mode
 * @param {string} [props.whiteLabelState.labelColor] - Optional color for the label
 * @param {string} [props.headerText] - Header text to display when white label client exists but no logo is provided
 * @returns {JSX.Element|null} Logo component or null
 */
export default function WhiteLabelLogo({
  whiteLabelState,
  headerText = 'Employee Login',
}) {
  const { urlLogo, hasWhiteLabelClient, isEnclosedMode, labelColor } =
    whiteLabelState;

  if (!!isEnclosedMode) {
    return null;
  }

  if (!!hasWhiteLabelClient && urlLogo) {
    return (
      <StyledBox display="flex" justifyContent="center" alignItems="center">
        <HeaderImage src={urlLogo} alt="White Label Logo" />
      </StyledBox>
    );
  }

  if (!!hasWhiteLabelClient && !urlLogo) {
    return (
      <HeaderTypography
        sx={{
          color: hasValue(labelColor) ? labelColor : 'inherit',
        }}
      >
        {headerText}
      </HeaderTypography>
    );
  }

  if (!hasWhiteLabelClient) {
    // If we want to add a default logo in the future instead of text, we can
    // import Logo from 'assets/WFHLogoAndText.png';
    // return <HeaderImage src={Logo} alt="Workforce Hub Logo" />;
    return <HeaderTypography>{headerText}</HeaderTypography>;
  }

  return null;
}

WhiteLabelLogo.propTypes = {
  whiteLabelState: PropTypes.object,
  headerText: PropTypes.string,
};

/** styled components */

const StyledBox = styled(Box)(() => ({
  gridArea: 'header',
}));
